/* WarningsMessageComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;

const Renderer = require("./WarningsMessageRenderer");

/**
 * @class WarningsMessageComponent
 * @extends EventEmitter
 *
 * @fires WarningsMessageComponent#Data
 * @fires WarningsMessageComponent#Shutdown
 */

/**
 * @typedef WarningItem
 * @description "warnings" property item for License
 * @type {Object}
 * @property {boolean} [timeWarning] - true is timeWarning type
 * @property {boolean} [deviceWarning] - true is deviceWarning type
 * @property {number} percentUsed
 * @property {string} msg
 */
/**
 * @typedef {WarningItem[]} SolutionWarnings
 */
class WarningsMessageComponent extends EventEmitter {
    constructor() {
        super();
        /**
         * @type {?WarningItem[]}
         * @private
         */
        this._data = null;
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer && this._renderer.getRootElement();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        this.removeAllListeners();
        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = null;
                this._data = null;
                this._shutdownProm = null;
                this._listeners = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _triggerShutdown() {
        /**
         * @event WarningsMessageComponent#Shutdown
         */
        this.emit("Shutdown");
    }

    _triggerData(data) {
        /**
         * @event WarningsMessageComponent#Data
         * @param {WarningItem[]} data - new data
         */
        this.emit("Data", data);
    }

    /**
     *
     * @param {WarningItem[]} data
     * @param {boolean} silent
     * @private
     */
    _setData(data, silent = false) {
        if (!silent && JSON.stringify(this._data) !== JSON.stringify(data)) {
            this._triggerData(data);
        }
        this._data = data;
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    getData() {
        return this._data;
    }

    /**
     *
     * @param {{warnings: WarningItem[]}[]} [licenseStateProps]
     */
    setData(licenseStateProps) {
        if (typeof licenseStateProps !== "undefined") {
            const data = licenseStateProps.reduce((warningsList, { warnings = [] }) => warningsList.concat(warnings), []);
            this._setData(data);
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = WarningsMessageComponent;
